import {  useState } from "react";
import { Close } from "@components/buttons/close";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { Button } from "@components/buttons/button";
import { RaffleCreateCampaignCodeByText } from "@components/raffle-creation/tabs/text";
import { RaffleCreateCampaignCodeBySearch } from "@components/raffle-creation/tabs/search";

interface IProps {
  campaignName: string;
  raffleType: number;
  isOpen: boolean;
  onClose: (campaignCode?: string) => void;
}

export function ModalRaffleCampaignCode({
  campaignName,
  raffleType,
  isOpen,
  onClose,
}: IProps) {
  // --- Default Variables --- //
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  // --- Importants Use States --- //
  const [isCampaignCodeValidated, setIsCampaignCodeValidated] =
    useState<boolean>(false);
  const [campaignCode, setCampaignCode] = useState<string | undefined>(
    undefined
  );

  // --- Page Control --- //
  const [activeTab, setActiveTab] = useState("criacao");

  function handleClose() {
    setTimeout(() => onClose(campaignCode), 300);
  }

  const handleCampaignCodeChange = (
    campaignCode: string | undefined,
    isValidated: boolean
  ) => {
    setCampaignCode(campaignCode);
    setIsCampaignCodeValidated(isValidated);
  };

  return (
    <>
      <div
        className={`modal fade ${isOpen ? "show" : ""}`}
        style={{ display: isOpen ? "block" : "none" }}
        aria-labelledby="staticBackdropLabel"
        aria-hidden={!isOpen}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title fw-bold" id="contentModallLabel">
                Criação ou Seleção de Código de Campanha
              </h5>
              <Close onPress={handleClose} />
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              {/* Tab Navigations */}
              <ul
                className="nav nav-tabs mb-3"
                id="campaignTabs"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "criacao" ? "active" : ""
                    }`}
                    id="criacao-tab"
                    type="button"
                    role="tab"
                    aria-controls="criacao"
                    aria-selected={activeTab === "criacao"}
                    onClick={() => setActiveTab("criacao")}
                  >
                    Criação
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "buscar" ? "active" : ""
                    }`}
                    id="buscar-tab"
                    type="button"
                    role="tab"
                    aria-controls="buscar"
                    aria-selected={activeTab === "buscar"}
                    onClick={() => setActiveTab("buscar")}
                  >
                    Buscar
                  </button>
                </li>
              </ul>

              {/* The Content's Tabs */}
              <div className="tab-content" id="campaignTabsContent">
                {/* Creation' Tab */}
                <div
                  className={`tab-pane fade ${
                    activeTab === "criacao" ? "show active" : ""
                  }`}
                  id="criacao"
                  role="tabpanel"
                  aria-labelledby="criacao-tab"
                >
                  <RaffleCreateCampaignCodeByText
                    campaignName={campaignName}
                    onCampaignCodeChange={handleCampaignCodeChange}
                  />
                </div>

                {/* Search Tab */}
                <div
                  className={`tab-pane fade ${
                    activeTab === "buscar" ? "show active" : ""
                  }`}
                  id="buscar"
                  role="tabpanel"
                  aria-labelledby="buscar-tab"
                >
                  <RaffleCreateCampaignCodeBySearch />
                </div>
              </div>

              {/* The main button */}
              <div className="col-md-12 mb-2 col-12 text-end">
                <Button
                  onClick={handleClose}
                  children={isCampaignCodeValidated ? "Salvar" : "Fechar"}
                  className={`btn btn-${
                    isCampaignCodeValidated ? "success" : "secondary"
                  } py-2 px-5`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
